var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00002 8H9.50002V10.5M5.00002 4H2.50002V1.5M9.70901 4.5015C9.42868 3.8076 8.95929 3.20625 8.35421 2.76583C7.74913 2.32541 7.03263 2.06357 6.28615 2.01008C5.53967 1.95659 4.79315 2.11359 4.13146 2.46324C3.46976 2.81289 2.91943 3.34116 2.54302 3.988M2.29102 7.4985C2.57141 8.19228 3.0408 8.79349 3.64583 9.23382C4.25086 9.67414 4.96728 9.93592 5.71366 9.98941C6.46004 10.0429 7.20647 9.88595 7.8681 9.5364C8.52974 9.18684 9.08005 8.65871 9.45652 8.012",
    stroke: "#252525",
    strokeOpacity: 0.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReload);
export default __webpack_public_path__ + "static/media/ic-reload.00955be29d92bc1f1d4c351c587798e3.svg";
export { ForwardRef as ReactComponent };